import React from 'react';
import { Modal, Avatar, List } from 'antd';
import { UserOutlined, HeartFilled } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const ReactionUsers = ({
  reactionUsers,
  isVisible,
  onClose,
  isLoading = false,
}) => {
  const navigate = useNavigate();

  const handleUserClick = (userId, userType) => {
    navigate(`/view-user?userid=${userId}&usertype=${userType}`);
  };

  const getUserTypeName = (userType) => {
    if (userType === 1) {
      return 'Founder';
    } else if (userType === 2) {
      return 'Investor';
    } else if (userType === 3) {
      return 'Expert';
    }

    return 'User';
  };

  return (
    <Modal
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <HeartFilled style={{ color: '#ff4d4f' }} />
          <span>Reactions</span>
        </div>
      }
      open={isVisible}
      onCancel={onClose}
      footer={null}
      width={400}
      bodyStyle={{
        maxHeight: '60vh',
        overflow: 'auto',
      }}
    >
      <List
        itemLayout="horizontal"
        loading={isLoading}
        dataSource={reactionUsers}
        locale={{ emptyText: 'No reactions yet' }}
        renderItem={(user) => (
          <List.Item
            style={{ cursor: 'pointer' }}
            onClick={() => handleUserClick(user.id, user.user_type_id)}
          >
            <List.Item.Meta
              avatar={
                <Avatar
                  src={user.profile_image}
                  icon={!user.profile_image && <UserOutlined />}
                  size={40}
                />
              }
              title={`${user.first_name} ${user.last_name}`}
              description={getUserTypeName(user.user_type_id)}
            />
          </List.Item>
        )}
      />
    </Modal>
  );
};

export default ReactionUsers;
